import React from 'react';
import styled from 'styled-components';
import { getColor } from '../../../styling/mixins/colors';
import { text } from '../../../styling/mixins/typography';
import Checkbox from '../../Inputs/Checkbox';
import RadioButton from '../../Inputs/Radiobutton';
import { FilterElementAttributes } from '../types/FilterElementAttributes';

interface StyledFilterCheckboxProps {
  $hasProducts: boolean;
}

const StyledFilterCheckbox = styled.label<StyledFilterCheckboxProps>`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0.4rem 0;
  color: ${(p) => (p.$hasProducts ? getColor('gray', 500) : null)};
  pointer-events: ${(p) => (p.$hasProducts ? 'none' : 'auto')};
  .label {
    ${text('large')}
    input {
      border-color: ${(p) => (p.$hasProducts ? getColor('gray', 300) : null)};
    }
  }
  .fake-select {
    border-radius: 2px;
    width: 16px;
    height: 16px;
    border: 1px solid ${getColor('gray', 300)};
    background-color: ${getColor('gray', 100)};
  }

  .checkbox-wrapper {
    display: flex;
    align-items: center;
    color: ${getColor('grey', 500)};
    ${text('small')}

    span {
      margin-right: 0.6rem;
    }
  }
`;

const FilterCheckbox = ({
  filter,
  option,
  onChange,
}: FilterElementAttributes) => {
  return option ? (
    <StyledFilterCheckbox
      $hasProducts={option.quantity == 0 ? true : false}
      key={option.id}
    >
      <span className="label">{option.label}</span>
      <span className="checkbox-wrapper">
        {option.quantity && option.quantity > 0 ? (
          <span>({option.quantity})</span>
        ) : (
          option.quantity != null && <span>(0)</span>
        )}
        {!filter.singleSelect && option.quantity != 0 ? (
          <Checkbox
            inputSize="small"
            checked={filter.selectedOptions.indexOf(option.id) != -1}
            onChange={() => onChange && onChange(filter.id, option.id)}
          />
        ) : (
          <div className="fake-select"></div>
        )}
        {filter.singleSelect && (
          <RadioButton
            inputSize="small"
            checked={filter.selectedOptions.indexOf(option.id) != -1}
            onChange={() => onChange && onChange(filter.id, option.id)}
          />
        )}
      </span>
    </StyledFilterCheckbox>
  ) : null;
};

export default FilterCheckbox;
